import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';
import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

@Component({
  selector: 'app-wbs-dictionary-definitions',
  templateUrl: './wbs-dictionary-definitions.component.html',
  styleUrls: ['./wbs-dictionary-definitions.component.css']
})
export class WbsDictionaryDefinitionsComponent implements OnInit, OnDestroy {
  columns: Array<Object>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    this.columns = this.report.WBSDictionaryDefinitions.columns;
    this.data = this.report.WBSDictionaryDefinitions.data;
    this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
  }

  ngOnDestroy() {
    this.reloadSubscription.unsubscribe();
  }

  reload() {
    this.data = this.report.WBSDictionaryDefinitions.data;
    const gridInstance = this.gridContext.getInstance('WBSDictionaryDefinitions');
    gridInstance.loadData(this.data);
  }
}


// WEBPACK FOOTER //
// ./src/app/wbs-dictionary-definitions/wbs-dictionary-definitions.component.ts